import { ChangeDetectionStrategy, Component, EventEmitter, input, InputSignal, Output } from '@angular/core';
import { SzIconComponent } from '../../display/sz-icon';

@Component({
  selector: 'sz-run-row',
  templateUrl: './sz-run-row.component.html',
  styleUrls: ['./sz-run-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SzIconComponent]
})
export class SzRunRowComponent {
  readonly index: InputSignal<number> = input.required<number>();
  readonly value: InputSignal<string> = input.required<string>();
  readonly unit: InputSignal<string | null> = input<string | null>(null);
  readonly best: InputSignal<boolean> = input<boolean>(false);
  readonly interactive: InputSignal<boolean> = input<boolean>(false);

  @Output() readonly remove: EventEmitter<void> = new EventEmitter<void>();
  @Output() readonly edit: EventEmitter<void> = new EventEmitter<void>();

  formatIndex(): string {
    const value: number = this.index();
    return `RUN ${value.toString().padStart(2, '0')}`;
  }

  onEdit(): void {
    if (!this.interactive()) {
      return;
    }
    this.edit.emit();
  }

  onRemove(event: Event): void {
    event.stopPropagation();
    this.remove.emit();
  }
}
